import { render, staticRenderFns } from "./RedsysButton.vue?vue&type=template&id=5528e16e"
import script from "./RedsysButton.vue?vue&type=script&lang=js"
export * from "./RedsysButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports